import { useParams } from 'react-router-dom';

import InquiryEnrollment from '~/components/maud/patients/profile/inquiryEnrollment';

const EnrollmentPage = () => {
  const { patientId } = useParams<{ patientId: string }>();

  return <InquiryEnrollment patientId={patientId} />;
};

export default EnrollmentPage;
